import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerDomainWhois extends AManagerApi {
    protected _url: string = '/owner/domain/whois';
}
